import React from 'react';
import type { ToggleButtonProps as MuiToggleButtonProps } from '@mui/material';
import { ToggleButton as MuiToggleButton } from '@mui/material';

export const ToggleButton: React.FC<MuiToggleButtonProps> = ({ ...props }) => {
  return <MuiToggleButton {...props} />;
};

export const ToggleButtons = ToggleButton;
